import { Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import styled from 'styled-components';

interface Props {
	children?: string;
}

const elements = {
	container: styled.div`
		display: flex;
		margin: 0 calc(-1 * ${tokens.spacing.x1_5}) calc(-1 * ${tokens.spacing.x2});
		padding: ${tokens.spacing.x1} ${tokens.spacing.x1_5};
		background-color: ${tokens.color.bg.highlight};
		color: ${tokens.color.content.interactive};
		box-sizing: content-box;
		align-items: center;
		min-height: 32px;

		${tokens.breakpointQuery.medium} {
			min-height: auto;
		}
	`,
};

export function BottomBanner({ children }: Props): JSX.Element | null {
	if (children == null) return null;

	return (
		<elements.container>
			<Text variant='labelSemiBold'>{children}</Text>
		</elements.container>
	);
}
